import {createContext} from 'react'
import {UserListStore} from './UserListStore';

export const storeContext = createContext({
    usersListStore: new UserListStore
});
